import { useContext, useState } from "react";
import { Avatar, Button, Grid, Stack, Typography } from "@mui/material"
import { ToolsModal } from "./modal/ToolsModal";
import { rqx } from "../../../../core/request/API";
import { env } from "../../../../core/Env";
import { ToolContext } from "../../../../core/context/ToolContext";
import { ToolShuffleLoader } from "../../loader/Loader";
import { DirectTabLoader } from "../../loader/DirectTabLoader";
import { MyToolIcons } from "../../global/Icons";

export const ToolListShuffle = () => {

    const { tool_state } = useContext(ToolContext);
    const {__SESSION, toolOwned, toolShuffle } = tool_state
    const [openModal, setOpenModal] = useState(false)

    const handleClickTools = async(tid) =>{
        let res = await rqx.get(`<<global>>/${env()}/tools/toolcb`, {tid: tid, env:env() !== 'prod' ? 'sandbox':'production'})
        if (res.msg === 'success') {
            let ssoUrls = `${res.tu[0].value}?ainfo=${encodeURI(JSON.stringify(__SESSION.data.ainfo))}`
            await DirectTabLoader(res.abbreviation+'WN', ssoUrls) // THIS IS FROM GLOBAL FOR THE OPEN TAB IN BROWSER
        }
    }
    
    return (
        toolShuffle.data.length === 0 ? 
            <ToolShuffleLoader/>
        :
            <Grid container minHeight="140px" width="100%" direction="row" alignItems="center" gap="12px">
                {(toolOwned.data.length > 3 ? toolShuffle.data : toolOwned.data)?.map((v,k) => (
                    <Grid item key={k} xs={2.8} lg={2.9} height="100%" width="100%" borderRadius="12px" border="1px solid #D6D9DB" bgcolor="#FFFFFF"
                        sx={{boxShadow:'0px 2px 4px 0px #00000005'}}
                    >
                        <Stack height="100%" gap="12px" p="24px">
                            <Stack direction="row" alignItems="center" gap="12px">
                                <Avatar src={JSON.parse(v.logo)} variant="square" sx={{height:'32px', width:'32px', borderRadius:'4px'}}/>
                                <Stack minWidth={0} gap="4px">
                                    <Typography fontSize={16} fontWeight={600} lineHeight="120%" letterSpacing="-0.75%" color="#292C2F" noWrap>
                                        {v.name}
                                    </Typography>
                                    <Typography fontSize={12} fontWeight={400} lineHeight="147%" letterSpacing="-0.75%" color="#292C2F" noWrap>
                                        {v.description}
                                    </Typography>
                                </Stack>
                            </Stack>
                            <Button onClick={()=>handleClickTools(v.tid)} sx={{height:'36px', width:'100%', borderRadius:'4px', bgcolor:'#F7F8F8','&:hover':{bgcolor:'#F7F8F8'} }}>
                                <Typography fontSize={12} fontWeight={400} lineHeight="142%" letterSpacing="0%" color="#292C2F">Open</Typography>
                            </Button>
                        </Stack>
                    </Grid>
                ))}
                {toolOwned.data.length > 3 && (
                    <Grid item xs={2.8} lg={2.9} height="140px" width="100%" borderRadius="12px" border="1px solid #D6D9DB" 
                        sx={{boxShadow:'0px 2px 4px 0px #00000005'}}
                        bgcolor="#FFFFFF"
                        display="flex"
                        alignItems="center"
                    >
                        <Button
                            onClick={()=>setOpenModal(true)}
                            sx={{
                                height:'100%', width:'100%',
                                '&:hover':{bgcolor:'#FFFFFF', borderRadius:'12px'}
                            }}
                        >
                            <Stack height="100%" justifyContent="center" alignItems="center" gap="4px" p="24px">
                                <MyToolIcons fill="#003022" stroke="#003022" width="32" height="32"/>
                                <Typography fontSize={12} fontWeight={400} lineHeight="142%" letterSpacing="0%" color="#292C2F">More Tools</Typography>
                            </Stack>
                        </Button>
                        <ToolsModal toolOwned={toolOwned.data} handleClickTools={handleClickTools} openModal={openModal} setOpenModal={setOpenModal}/>
                    </Grid>
                )}
            </Grid>
    )
}